import { Typography } from "@mui/material";

export default [
  {
    id: "0001",
    image:
      "https://images.pexels.com/photos/398468/pexels-photo-398468.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    title: "نقد عقل محض",
    text: (
      <p>
        کوششِ کانت، در کتابِ «نقد عقل محض» یا همان «سنجش خرد ناب» Kritik der
        reinen Vernunft، پاسخ به این پرسشِ متافیزیکی است که: من چه چیزی را
        می‌توانم بدانم؟ اما پیش از پرداختن به آن، باید درباره‌ی معنای دو واژه‌ی
        آلمانیِ Kritik و Rein که در نام کتاب آمده است اندیشید.
        <p></p>
        Kritik: این واژه در چهار معنای مختلف مورد استفاده قرار می‌گیرد: آزمایش،
        سنجش و قضاوت، مطابق با استانداردهای دقیقِ علمی، هنری و… (نقد، نقادی،
        سنجش، آزمودن، ارزیابی)، قضاوتِ منفی (انتقاد، خرده‌گیری)، اعلام یک نقطه‌ی
        عطفِ تعیین کننده درباره‌ی یک رویدادِ [خطرناک] (بحرانی، متشنج)، خطر یا
        موقعیتِ خطرناکِ قابل توجه. در اینجا منظور از Kritik، نقد، نقادی، سنجش،
        آزمودن و ارزشیابیِ علمی است و نه خرده‌گیری و انتقاد و قضاوتِ منفیِ
        غیرعلمی.
        <p></p>
        Rein: این واژه به معنایِ خالص، بی‌غش، سره، زدوده، ناب، پاک، تمیز و محض
        به‌کار می‌رود. در خالص بودن، نوعی ویژگیِ تک‌عنصری پنهان است. آن‌چه خالص
        است و با چیزی دیگر در نیامیخته است، به موجبِ درنیامیخته‌گی و بی‌غش بودن،
        نوعی امکانِ پژوهشِ باریک‌بینانه و دقیق‌تر را فراهم می‌آورد. حال پرسش
        اینجاست که چه چیزی می‌تواند عقل را ناخالص و ناپالوده نماید، که ما به
        دنبالِ نقد گونه‌ی ناب آن هستیم؟ تفاوت و ناهمسانیِ میانِ عقلِ ناب و عقلِ
        غیرناب در چیست؟ برای پاسخ به این پرسش، از مفهومی دیگر که برای ذهنِ
        معاصر، آشناتر و ملموس‌تر است، بهره می‌جوییم: ریاضیات. ریاضیات از یک سو
        در بسیاری از علومِ تجربی از جمله فیزیک، شیمی و… بکار گرفته شده و پایه‌ی
        دستیابی به نتایجِ دقیقِ علمی به منظور کشف و فهمِ طبیعت است. به طور مثال
        می‌توان به کمکِ آن، سرعتِ یک جسمِ در حالِ حرکت و یا فاصله‌ی میانِ دو
        سیاره‌ی مشخص را به دقت محاسبه نمود. عددی که در اینجا به عنوانِ فاصله
        محاسبه می‌شود، با دو سیاره‌ی مورد نظر، ارتباطِ مستقیم دارد و اگر سیاره
        دوم را با سیاره یا جسمِ آسمانیِ دیگری جایگزین نماییم، به احتمال زیاد، در
        محاسبه‌ی جدیدِ خود، به عدد دیگری دست می‌یابیم. اما ریاضیات سویه‌ی دیگری
        نیز دارد که می‌توان آن را به طورِ نمونه با گزاره‌ی: a=a روشن نمود. آن‌چه
        این گزاره را از مثال‌های پیشین متمایز می‌کند، عدم نیاز، عدم وابسته‌گی و
        عدم ارتباطِ آن با جهانِ خارج از ریاضیات است. این گزاره نه ارجاعی به
        طبیعت و جهانِ مادی دارد و نه برای فهمِ آن نیازی به جهانِ مادی است. از
        سویِ دیگر می‌توان دو طرفِ معادله را با هر علامتِ دیگری جایگزین کرد و
        گزاره هم‌چنان پذیرفتنی خواهد بود. این نوع از ریاضیات را ریاضیاتِ محض
        می‌نامیم. ریاضیاتی که مستقل، زدوده و خالص از جهانِ ماده است. ریاضیاتِ
        ناوابسته. ریاضیاتِ آزاد از جهانِ خارج از خود. درباره‌ی واژه‌ی «عقلِ محض»
        که در عنوان کتاب آمده است نیز، معنایِ «محض»، دقیقا به همین معناست. عقلِ
        محض یعنی عقلِ مستقل از تجربه.
        <p></p>
        اکنون می‌توان معنایِ عنوانِ کتاب را بهتر اندیشید: «نقد عقل محض» به معنای
        ارزیابی و سنجشِ علمی و روشمندِ عقلِ مستقل از تجربه است. تلاشی‌ست برای
        یافتنِ مرزهایی که عقلِ محض، فرای آنها دچار یاوه‌سرایی و بیهوده‌گویی
        می‌شود. به بیانِ سَلبی: چه چیزی را نمی‌توانم بدانم؟
      </p>
    ),
  },
  {
    id: "0002",
    image:
      "https://images.pexels.com/photos/9962618/pexels-photo-9962618.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "چه چیزی را می‌توانم بدانم؟",
    text: (
      <p>
        ایمانوئل کانت کوشید تا در آثارش به سه پرسش در ساحت‌های متافیزیک، اخلاق و
        دین پاسخ گوید. متافیزیک: چه چیزی را می‌توانم بدانم؟ اخلاق: چه باید انجام
        دهم؟ دین: به چه باید امید داشته باشم؟
        <p></p>
        در کتابِ نقد عقل محض، به پرسشِ اول پاسخ داده می‌شود. اما این پاسخ، بر
        خلافِ اخلاف‌اش، کاوش در امکانِ شناختِ آزاد از تجربه بود. او کوشید تا با
        تعیین و تبیینِ حدودِ عقلِ مستقل از تجربه، راه را بر فریب‌ها و کژروی‌های
        عقل، که ما را به بی‌راه‌های متافیزیکی می‌کشاند، بربندد.
      </p>
    ),
  },
  {
    id: "0003",
    image:
      "https://images.pexels.com/photos/10012572/pexels-photo-10012572.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "روشِ استعلایی",
    text: (
      <p>
        به عنوانِ اولین قدم در تبیینِ حدودِ عقل محض، یعنی پژوهش درباره‌ی حدودِ
        عقل نوعی روشِ تحقیق تحت عنوانِ روش ِ نقادی (kritisch) و یا روشِ استعلایی
        (transzendental) در مقابلِ روشِ دگماتیست‌ها و شکاکان بنا نهاده شد.
        ویژگیِ بارزِ روشِ استعلایی، نه هم‌چون فیلسوفانِ پیشاکانتی، پرداختنِ
        مستقیم به شی‌ها و ذاتِ آن‌ها، که اندیشیدن درباره‌ی چگونه‌گیِ شناختِ
        سوژه‌ی شناسیک از شی‌ها است. علاوه بر آن این شیوه‌ی استعلایی، می‌بایستی
        دارایِ ویژگیِ دیگری بجز پیشینی بودن نیز باشد.
        <p></p>
        <Typography sx={{ fontStyle: "italic", fontSize: 14 }}>
          Ich nenne alle Erkenntnis transzendental, die sich nicht sowohl mit
          Gegenständen, sondern mit unserer Erkenntnisart von Gegenständen,
          insofern diese a priori möglich sein soll, überhaupt beschäftigt. Ein
          System solcher Begriffe würde Transzendental-Philosophie heißen.
          <Typography direction="left">
            Immanul Kant, Kritik der reinen Vernunft
          </Typography>
          من هر شناختی را که نه به اشیا، بلکه به نوعِ شناخت ما از اشیا به طور
          کلی می‌پردازد، تا آنجا که این شناخت، به طور پیشینی ممکن باشد، استعلایی
          می‌نامم. سیستمی از این‌گونه مفاهیم می‌بایست فلسفه‌ی استعلایی نامیده
          شود.
        </Typography>
        <br />
        باید توجه داشت که تمرکزِ وی به موضوعِ عقلِ مستقل از تجربه، ارائه‌ی نوعِ
        جدیدی از شک‌ورزی، مشابه شکاکیتِ ایده‌آلیست‌ها که به وجودِ چیزها شک
        می‌ورزیدند، نبود. وی می‌کوشید تا با بهره‌گیری از ایده‌آلیسمِ استعلایی یا
        انتقادیِ خویش، فاصله‌ی خود را به طورِ هم‌زمان از افراط‌ و تفریط‌های
        ایده‌آلیسم و رئالیسم حفظ کرده و از این راه بتواند یک روشِ علمی که به
        کمکِ آن بتوان وجودِ چیزها را ادراک نمود ، پیشا رویِ ما قرار نهد.
      </p>
    ),
  },
];
